import i18next from 'i18next';

import { getPdfFile } from 'common/api/renderTemplate';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import { SET_IS_DOWNLOADING } from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

import downloadFile from './downloadFile';

export default (contentId, downloadFormat, name = i18next.t('File')) =>
    (dispatch) => {
        const newValues = {
            quality: downloadFormat,
            templateId: contentId,
            templateName: name,
        };
        dispatch(multiTemplateReviewActions[SET_IS_DOWNLOADING](true));
        return getPdfFile(newValues)
            .then((response) => {
                dispatch(multiTemplateReviewActions[SET_IS_DOWNLOADING](false));
                dispatch(downloadFile(name, response.data, 'pdf'));
                showToast({ body: i18next.t('It was created successfully') });
            })
            .catch((error) => {
                dispatch(multiTemplateReviewActions[SET_IS_DOWNLOADING](false));
                showReponseErrorsAsAlert(dispatch, error?.response);
            });
    };
